import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { init_safecharge_apple_pay, open_safecharge_apple_pay, set_safecharge_apple_result, billingCheckout, billingPlaceOrder } from '../../../../../../api'
import createScript from '../../../../../utils/create-script'


export default props => {
    const { onError, country, orderTotal, payMethod, inputOrder, shoudBilling, clickHandle, isFastPayment, check } = props
    const [ready, setReady] = useState(false)
    const [account, setAccount] = useState({})
    const [instance, setInstance] = useState(null)
    const global = useSelector(state => state.global)
    const isSandbox = global?.config?.env === 'sandbox'

    useEffect(async () => {
        const [a, b, response] = await Promise.all([
            createScript('safecharge-pay-script', 'https://cdn.safecharge.com/safecharge_resources/v1/websdk/safecharge.js'),
            createScript('safecharge-applepay-script', 'https://cdn.safecharge.com/safecharge_resources/v1/sc_api_applepay.min.js'),
            init_safecharge_apple_pay({ payMethod })
        ])

        if (response.code === 200 && response.result) {
            setAccount(response.result)
            if (window.SafeCharge) {
                setInstance(window.SafeCharge({
                    env: isSandbox?'int': 'prod', // Nuvei API environment - 'int' (integration) or 'prod' (production - default if omitted)
                    merchantId: response.result.merchantId, // your Merchant ID provided by Nuvei
                    merchantSiteId: response.result.merchantSiteId, // your Merchant site ID provided by Nuvei
                }))
            }
        } else {
            onError({
                message: response.result || 'Network Error.'
            })
        }

        setReady(true)
    }, [])

    const payWithSafecharge = async (token, callback) => {

        let orderResponse
        if (inputOrder) {
            orderResponse = {
                result: inputOrder,
                code: 200
            }
        } else {

            if (shoudBilling) {
                await billingCheckout()
            }

            orderResponse = await billingPlaceOrder(isFastPayment)
        }

        if (orderResponse?.code === 200 && orderResponse?.result) {

            const order = orderResponse?.result
            const openResponse = await open_safecharge_apple_pay({
                orderId: order?.id,
                merchantSiteId: account?.merchantSiteId,
                payMethod
            })

            if (openResponse?.code === 200 && openResponse?.result) {
                const {
                    openOrderResponse,
                    email,
                    country,
                    ip
                } = openResponse?.result


                instance.createPayment({
                    sessionToken: openOrderResponse?.sessionToken,
                    merchantId: openOrderResponse?.merchantId,
                    merchantSiteId: openOrderResponse?.merchantSiteId,
                    clientUniqueId: openOrderResponse?.clientUniqueId, // optional
                    paymentOption: {
                        card: {
                            externalToken: {
                                externalTokenProvider: "ApplePay",
                                mobileToken: JSON.stringify(token)
                            }
                        }
                    },
                    billingAddress: {
                        email: email,
                        country: country
                    },
                    'deviceDetails': {
                        'ipAddress': ip
                    }
                 },async res => {
                    console.log(res)
                    // alert(JSON.stringify(res))

                    await set_safecharge_apple_result({
                        ...res,
                        transactionId: order?.transactionId,
                        sessionToken: openOrderResponse?.sessionToken,
                        payMethod,
                    }).catch(e => {
                        console.error(e)
                    })

                    callback(res)

                    if(res.result === 'APPROVED'){
                        window.location.href = `/order-confirm/${order.transactionId}`
                    }else{
                        onError({
                            message: res?.errorDescription || res?.reason || 'Network Error'
                        })
                    }
                 })
            }
        }
    }

    const applepayClickHandle = async e => {

        if (!ready) return

        try {
            clickHandle?.()
            if(check){
                if(!check()){
                    return false
                }
            }
        } catch (error) {
            
        }

        const paymentRequest = {
            merchantSiteId: account?.merchantSiteId,
            env: isSandbox ? 'int': 'prod', //
            countryCode: country,
            currencyCode: orderTotal.currency,
            total: {
                label: 'Order total',
                amount: orderTotal.amount,
            },
        }

        let session = window.sfc.applePay.buildSession(paymentRequest, (result, completion) => {
            console.log(result)
            // result
            // {"token":{"paymentData":{"data":"S+EnsIhqB+WofaTVE5d/JTTbJiWXnY4pzvuSjPqIYRF44WvttcIXzFvr4Q5pvMUsSOHTC3H1S0aFYmww3I3St/hWVh5hBa4mxj5lFWycWfu6HqTtvolmjOXh618H4UlfB+Z2fKjpo1ESbY+M571GY4HFgWW4ry89uoFl2UgauDjnzzgcHNlZfsBsGtdog/RERRPuWlMfG0qHxjj3rfKnAeXRr1wH8Mra34NNLJsEo+TAVOVFBhWyLH+RdfT/UBLPVnrWYCts7Kj5CDxfWp3aAzPhj1QxS0Q4XvMagYffV3k0lEmVIH+a9G7JPE/dQuRmeJDjzzrQppxmZka8NdC3q5UPRKs1Uj1DMTzTh21H8mjhJs5JWLiV9gCiNpTKHbo02EVDtMRODtXQ+ZX2V5MZ","signature":"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","header":{"publicKeyHash":"Mjiu4PLiqVUKhKO5bX55JoNA1VMN2kIRIzPF8XV0cfc=","ephemeralPublicKey":"MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAE6EpWDhyLvFgf0sMf3lTM2h7UZoPNmbCLCj8hEo3OPpNhqhRL/+OnzhuXmV6ZzjCTRXh0Uy1n6oalS1YPsoboCg==","transactionId":"3d125668a66b14ab13dba2761d838a7a3a767b4276f66bc915851ad236357011"},"version":"EC_v1"},"paymentMethod":{"displayName":"MasterCard 0049","network":"MasterCard","type":"credit"},"transactionIdentifier":"3D125668A66B14AB13DBA2761D838A7A3A767B4276F66BC915851AD236357011"}}
            payWithSafecharge(result, function (response) {
                // depending on status returned, completion method should be called with true or false
                if (response.result && response.result === 'APPROVED') {
                    completion(true)       
                } else {
                    completion(false)
                }
            })
            //session.abort()
        })

        session.oncancel = (evt) => {
            console.log('cancelled', evt)
        }

        /* overlay is triggered*/
        session.begin()

    }

    return <div onClick={applepayClickHandle} class="apple-pay-button-with-text apple-pay-button-white-with-text">
        <span class="text">Buy with</span>
        <span class="logo"></span>
    </div>
}